import React from 'react';
import { motion } from 'framer-motion';
import { Search, Filter, Building2, BadgeCheck, Check, SlidersHorizontal, Mail, Phone, Lock, Star, FileText, Copy, ChevronDown, TrendingUp, Users, Send, MessageSquare, FolderKanban } from 'lucide-react';
// Platform Icons
const TTIco = () => <img src="https://cdn.magicpatterns.com/patterns/figma-images/HPPMfQF9zbBNm5oHh69dtz/362-1248.png" alt="TikTok" className="w-3.5 h-3.5 inline-block" data-id="element-1038" />;
const IGIco = () => <img src="https://cdn.magicpatterns.com/patterns/figma-images/HPPMfQF9zbBNm5oHh69dtz/362-1249.png" alt="Instagram" className="w-3.5 h-3.5 inline-block" data-id="element-1039" />;
const WindowBar = ({
  title,
  approved = false
}: {
  title: string;
  approved?: boolean;
}) => <div className="flex items-center gap-2 px-4 py-3 border-b border-gray-100 bg-gray-50/70" data-id="element-1040">
    <div className="flex items-center gap-1.5" data-id="element-1041">
      <span className="w-2.5 h-2.5 rounded-full bg-red-400/70" data-id="element-1042" />
      <span className="w-2.5 h-2.5 rounded-full bg-amber-400/70" data-id="element-1043" />
      <span className="w-2.5 h-2.5 rounded-full bg-emerald-400/70" data-id="element-1044" />
    </div>
    <span className="ml-2 text-xs font-semibold text-gray-500" data-id="element-1045">{title}</span>
    {approved && <span className="ml-auto inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-gray-100 text-gray-500 text-[9px] font-semibold uppercase tracking-wider" data-id="element-1046">
        <Lock size={8} data-id="element-1047" /> Approved Access
      </span>}
  </div>;
const floatY = (delay = 0, distance = 8) => ({
  animate: {
    y: [0, -distance, 0]
  },
  transition: {
    duration: 4,
    repeat: Infinity,
    ease: 'easeInOut' as const,
    delay
  }
});
export const LayeredPartnerRosterMockup = () => {
  const creators = [{
    name: 'David Kim',
    cat: 'Tech',
    followers: '3.1M',
    photo: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=160&h=160'
  }, {
    name: 'Sarah Jenkins',
    cat: 'Lifestyle',
    followers: '890K',
    photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=160&h=160'
  }, {
    name: 'Marcus Chen',
    cat: 'Gaming',
    followers: '1.5M',
    photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=160&h=160'
  }, {
    name: 'Elena Rodriguez',
    cat: 'Beauty',
    followers: '1.2M',
    photo: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=160&h=160'
  }];
  return <div className="relative h-[440px] w-full" data-id="element-1048">
      <div className="absolute -inset-6 bg-gradient-to-tr from-purple-100/40 via-zano-lavender/30 to-blue-100/20 rounded-[2.5rem] blur-2xl -z-10" data-id="element-1049" />
      <div className="absolute inset-0 bg-white rounded-2xl border border-gray-200 shadow-float overflow-hidden flex flex-col text-left" data-id="element-1050">
        <WindowBar title="Partner Rosters" approved data-id="element-1051" />

        <div className="p-4 border-b border-gray-100 bg-gray-50/30" data-id="element-1052">
          <div className="flex items-center gap-3" data-id="element-1053">
            <div className="w-10 h-10 bg-gray-900 text-white rounded-lg flex items-center justify-center text-xs font-bold shadow-sm" data-id="element-1054">
              ABC
            </div>
            <div data-id="element-1055">
              <h3 className="text-sm font-bold text-gray-900" data-id="element-1056">
                ABC Talent Agency
              </h3>
              <p className="text-[11px] text-gray-500 flex items-center gap-1 mt-0.5" data-id="element-1057">
                <Users size={10} data-id="element-1058" /> 142 Exclusive Creators
              </p>
            </div>
          </div>
        </div>

        <div className="p-4 pb-4 grid grid-cols-2 gap-3 overflow-hidden" data-id="element-1059">
          {creators.map((c, i) => <div key={i} className="border border-gray-100 rounded-xl p-3 bg-white hover:border-purple-300/50 transition-colors" data-id="element-1060">
              <div className="flex items-center gap-2.5" data-id="element-1061">
                <img src={c.photo} alt={c.name} className="w-11 h-11 rounded-full object-cover" data-id="element-1062" />
                <div className="min-w-0" data-id="element-1063">
                  <p className="text-xs font-semibold text-gray-900 truncate" data-id="element-1064">
                    {c.name}
                  </p>
                  <p className="text-[10px] text-gray-500" data-id="element-1065">{c.cat}</p>
                </div>
              </div>
              <div className="flex items-center justify-between mt-2.5" data-id="element-1066">
                <span className="flex items-center gap-1 text-[10px] font-medium text-gray-600" data-id="element-1067">
                  <TTIco data-id="element-1068" /> {c.followers}
                </span>
                <span className="inline-flex items-center gap-0.5 text-[9px] font-semibold text-emerald-600" data-id="element-1069">
                  <BadgeCheck size={9} data-id="element-1070" /> Exclusive
                </span>
              </div>
            </div>)}
        </div>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.3
    }} className="absolute -top-4 -right-4 sm:-right-6 z-20" data-id="element-1071">
        <motion.div {...floatY(0.2)} className="bg-white rounded-xl border border-gray-200 shadow-[0_20px_40px_-15px_rgba(0,0,0,0.15)] p-3 w-48" data-id="element-1072">
          <div className="flex items-center gap-1.5 mb-1" data-id="element-1073">
            <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" data-id="element-1074" />
            <p className="text-[11px] font-bold text-gray-900" data-id="element-1075">
              Live Sync Active
            </p>
          </div>
          <p className="text-[10px] text-gray-500 leading-snug" data-id="element-1076">
            Roster updates automatically. No more asking for PDFs.
          </p>
        </motion.div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.5
    }} className="absolute -bottom-5 -left-4 sm:-left-6 z-20" data-id="element-1077">
        <motion.div {...floatY(0.9)} className="bg-white rounded-xl border border-gray-200 shadow-[0_20px_40px_-15px_rgba(0,0,0,0.15)] p-3 w-52" data-id="element-1078">
          <div className="flex items-center gap-2 mb-2" data-id="element-1079">
            <div className="p-1.5 bg-purple-50 rounded-md" data-id="element-1080">
              <FolderKanban size={12} className="text-purple-600" data-id="element-1081" />
            </div>
            <p className="text-[11px] font-bold text-gray-900" data-id="element-1082">
              Client Campaign
            </p>
          </div>
          <button className="w-full bg-gray-900 text-white text-[10px] font-semibold py-1.5 rounded-md" data-id="element-1083">
            Add to shortlist
          </button>
        </motion.div>
      </motion.div>
    </div>;
};
export const LayeredAListWedgeMockup = () => {
  return <div className="relative h-[440px] w-full" data-id="element-1084">
      <div className="absolute -inset-6 bg-gradient-to-tr from-amber-100/40 via-zano-pink/20 to-zano-lavender/30 rounded-[2.5rem] blur-2xl -z-10" data-id="element-1085" />
      <div className="absolute inset-0 bg-white rounded-2xl border border-gray-200 shadow-float overflow-hidden flex flex-col text-left" data-id="element-1086">
        <WindowBar title="Roster Database" approved data-id="element-1087" />
        <div className="p-4" data-id="element-1088">
          <div className="relative w-full" data-id="element-1089">
            <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-zano-pink" data-id="element-1090" />
            <div className="w-full pl-9 pr-3 py-2.5 border-2 border-zano-pink/40 rounded-lg text-sm font-medium text-gray-900 bg-white shadow-sm" data-id="element-1091">
              Michelle Brown
            </div>
          </div>
          <p className="text-[11px] text-gray-400 mt-2 mb-3" data-id="element-1092">1 result</p>

          <div className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-1093">
            <div className="p-4 flex items-center gap-3 border-b border-gray-100" data-id="element-1094">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=120&h=120" alt="Michelle Brown" className="w-14 h-14 rounded-full object-cover" data-id="element-1095" />
              <div className="min-w-0" data-id="element-1096">
                <h3 className="text-base font-bold text-gray-900 leading-tight" data-id="element-1097">
                  Michelle Brown
                </h3>
                <div className="flex items-center gap-2 mt-1" data-id="element-1098">
                  <span className="flex items-center gap-1 text-[11px] font-medium text-gray-600" data-id="element-1099">
                    <TTIco data-id="element-1100" /> 8.4M
                  </span>
                  <span className="flex items-center gap-1 text-[11px] font-medium text-gray-600" data-id="element-1101">
                    <IGIco data-id="element-1102" /> 3.1M
                  </span>
                </div>
              </div>
            </div>
            <div className="p-4" data-id="element-1103">
              <div className="flex items-center gap-2 mb-2" data-id="element-1104">
                <div className="w-7 h-7 bg-gray-900 text-white rounded-md flex items-center justify-center text-[9px] font-bold" data-id="element-1105">
                  ABC
                </div>
                <span className="text-sm font-bold text-gray-900" data-id="element-1106">
                  ABC Talent Agency
                </span>
                <span className="ml-auto inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 text-[10px] font-semibold" data-id="element-1107">
                  <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" data-id="element-1108" />
                  Exclusive
                </span>
              </div>
              <div className="space-y-2 mt-3" data-id="element-1109">
                <p className="text-[9px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-1110">
                  Talent manager · John Smith
                </p>
                <div className="flex items-center justify-between gap-2 bg-gray-50 border border-gray-200 rounded-md px-2.5 py-1.5" data-id="element-1111">
                  <span className="flex items-center gap-2 text-xs font-medium text-gray-700 truncate" data-id="element-1112">
                    <Mail size={12} className="text-gray-400 shrink-0" data-id="element-1113" />
                    john@abctalentagency.com
                  </span>
                  <Copy size={12} className="text-gray-400 shrink-0" data-id="element-1114" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.4
    }} className="absolute -top-4 -right-3 sm:-right-5 z-20" data-id="element-1115">
        <motion.div {...floatY(0.3, 6)} className="flex items-center gap-1.5 bg-white rounded-full border border-amber-200 shadow-[0_15px_35px_-12px_rgba(0,0,0,0.2)] pl-2 pr-3 py-1.5" data-id="element-1116">
          <span className="w-6 h-6 rounded-full bg-amber-100 flex items-center justify-center" data-id="element-1117">
            <Star size={12} className="fill-amber-500 text-amber-500" data-id="element-1118" />
          </span>
          <span className="text-[11px] font-bold text-amber-700" data-id="element-1119">
            A-List Access
          </span>
        </motion.div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.6
    }} className="absolute bottom-2 -left-4 sm:-left-6 z-20" data-id="element-1120">
        <motion.div {...floatY(1.1)} className="bg-white rounded-xl border border-gray-200 shadow-[0_20px_40px_-15px_rgba(0,0,0,0.15)] p-3 w-48" data-id="element-1121">
          <div className="flex items-center gap-1.5 mb-1" data-id="element-1122">
            <span className="w-1.5 h-1.5 rounded-full bg-purple-500" data-id="element-1123" />
            <p className="text-[10px] font-bold text-gray-900" data-id="element-1124">
              Your Agency's Wedge
            </p>
          </div>
          <p className="text-[10px] text-gray-500 leading-snug" data-id="element-1125">
            Impress clients with direct access to the highest level of creators.
          </p>
        </motion.div>
      </motion.div>
    </div>;
};
export const LayeredAgencyOutreachMockup = () => {
  return <div className="relative h-[440px] w-full" data-id="element-1126">
      <div className="absolute -inset-6 bg-gradient-to-tr from-sky-100/40 via-zano-lavender/30 to-zano-pink/10 rounded-[2.5rem] blur-2xl -z-10" data-id="element-1127" />
      <div className="absolute inset-0 bg-white rounded-2xl border border-gray-200 shadow-float overflow-hidden flex flex-col text-left" data-id="element-1128">
        <WindowBar title="Campaign Sourcing" data-id="element-1129" />
        <div className="p-4 space-y-4 overflow-hidden" data-id="element-1130">
          <div className="bg-gray-50 border border-gray-200 rounded-xl p-3" data-id="element-1131">
            <div className="flex items-center gap-2 mb-2" data-id="element-1132">
              <MessageSquare size={14} className="text-zano-pink" data-id="element-1133" />
              <span className="text-xs font-bold text-gray-900" data-id="element-1134">
                Direct Email
              </span>
            </div>
            <div className="bg-white border border-gray-200 rounded-md p-2.5" data-id="element-1135">
              <p className="text-[10px] text-gray-400 mb-1" data-id="element-1136">
                To: john@abctalentagency.com
              </p>
              <p className="text-[10px] text-gray-400 mb-2" data-id="element-1137">
                Subject: Partnership for Summer Campaign
              </p>
              <p className="text-[10px] text-gray-600 leading-relaxed" data-id="element-1138">
                Hi John, we're casting for a new client campaign and would love
                to partner with your roster...
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3" data-id="element-1139">
            <div className="h-px bg-gray-200 flex-1" data-id="element-1140" />
            <span className="text-[10px] font-bold text-gray-400 uppercase" data-id="element-1141">
              OR
            </span>
            <div className="h-px bg-gray-200 flex-1" data-id="element-1142" />
          </div>

          <div className="bg-gray-50 border border-gray-200 rounded-xl p-3" data-id="element-1143">
            <div className="flex items-center gap-2 mb-2" data-id="element-1144">
              <Send size={14} className="text-zano-pink" data-id="element-1145" />
              <span className="text-xs font-bold text-gray-900" data-id="element-1146">
                Post Casting Call
              </span>
            </div>
            <div className="bg-white border border-gray-200 rounded-md p-2.5" data-id="element-1147">
              <div className="flex justify-between items-center mb-2" data-id="element-1148">
                <span className="text-[10px] font-semibold text-gray-700" data-id="element-1149">
                  Summer Skincare Launch
                </span>
                <span className="text-[10px] text-gray-500" data-id="element-1150">$10k - $20k</span>
              </div>
              <button className="w-full bg-zano-pink text-white rounded-md py-1.5 text-[10px] font-bold shadow-sm" data-id="element-1151">
                Blast to 400+ Agencies
              </button>
            </div>
          </div>
        </div>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.3
    }} className="absolute -top-4 -right-3 sm:-right-6 z-20" data-id="element-1152">
        <motion.div {...floatY(0.2)} className="bg-white rounded-xl border border-gray-200 shadow-[0_20px_40px_-15px_rgba(0,0,0,0.15)] p-3 w-48" data-id="element-1153">
          <div className="flex items-center gap-1.5 mb-1" data-id="element-1154">
            <span className="w-2 h-2 rounded-full bg-emerald-500" data-id="element-1155" />
            <p className="text-[11px] font-bold text-gray-900" data-id="element-1156">
              Happy to Partner
            </p>
          </div>
          <p className="text-[10px] text-gray-500" data-id="element-1157">
            Agencies want more brand deals for their talent. They're ready to
            work with you.
          </p>
        </motion.div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.55
    }} className="absolute -bottom-6 -left-4 sm:-left-8 z-30" data-id="element-1158">
        <motion.div {...floatY(1)} className="bg-white rounded-xl border border-gray-200 shadow-[0_20px_40px_-15px_rgba(0,0,0,0.15)] p-3 w-56" data-id="element-1159">
          <div className="flex items-center gap-2.5 mb-2" data-id="element-1160">
            <img src="https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=64&h=64" alt="Submission" className="w-9 h-9 rounded-full object-cover" data-id="element-1161" />
            <div className="min-w-0" data-id="element-1162">
              <p className="text-[11px] font-bold text-gray-900 truncate" data-id="element-1163">
                New submission
              </p>
              <span className="inline-flex items-center gap-1 text-[9px] font-semibold text-emerald-700" data-id="element-1164">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" data-id="element-1165" />
                Exclusive · ABC Talent Agency
              </span>
            </div>
          </div>
          <div className="flex justify-between items-center bg-gray-50 rounded-md border border-gray-100 px-2.5 py-1.5" data-id="element-1166">
            <span className="text-[10px] text-gray-500" data-id="element-1167">Quote</span>
            <span className="text-xs font-bold text-green-600" data-id="element-1168">$1,200</span>
          </div>
        </motion.div>
      </motion.div>
    </div>;
};